export const NIGERIAN_STATES = [
  "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue",
  "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu",
  "FCT (Abuja)", "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina",
  "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo",
  "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara",
];

export const OLEVEL_SUBJECTS = [
  "English Language", "Mathematics", "Physics", "Chemistry", "Biology",
  "Agricultural Science", "Economics", "Government", "Geography", "History",
  "Commerce", "Financial Accounting", "Technical Drawing", "Further Mathematics",
  "Christian Religious Studies", "Islamic Religious Studies", "Literature in English",
  "Civic Education", "Computer Studies", "Physical Education", "Home Economics",
  "Food and Nutrition", "Visual Art", "Music", "French",
];

export const OLEVEL_GRADES = ["A1", "B2", "B3", "C4", "C5", "C6", "D7", "E8", "F9"];

export const NIGERIAN_UNIVERSITIES = [
  "UNIVERSITY OF LAGOS (UNILAG), LAGOS STATE",
  "UNIVERSITY OF IBADAN (UI), OYO STATE",
  "OBAFEMI AWOLOWO UNIVERSITY (OAU), OSUN STATE",
  "UNIVERSITY OF NIGERIA, NSUKKA (UNN), ENUGU STATE",
  "AHMADU BELLO UNIVERSITY (ABU), KADUNA STATE",
  "UNIVERSITY OF BENIN (UNIBEN), EDO STATE",
  "FEDERAL UNIVERSITY OF TECHNOLOGY, MINNA, NIGER STATE",
  "FEDERAL UNIVERSITY OF TECHNOLOGY, AKURE, ONDO STATE",
  "FEDERAL UNIVERSITY OF TECHNOLOGY, OWERRI, IMO STATE",
  "ABUBAKAR TAFAWA BALEWA UNIVERSITY (ATBU), BAUCHI STATE",
  "BAYERO UNIVERSITY, KANO STATE",
  "USMAN DAN FODIO UNIVERSITY, SOKOTO STATE",
  "NNAMDI AZIKIWE UNIVERSITY (NAU), ANAMBRA STATE",
  "UNIVERSITY OF PORT HARCOURT, RIVERS STATE",
  "UNIVERSITY OF CALABAR, CROSS RIVER STATE",
  "UNIVERSITY OF MAIDUGURI, BORNO STATE",
  "UNIVERSITY OF ILORIN, KWARA STATE",
  "UNIVERSITY OF JOS, PLATEAU STATE",
  "AMBROSE ALLI UNIVERSITY, EDO STATE",
  "DELTA STATE UNIVERSITY, ABRAKA, DELTA STATE",
  "IMO STATE UNIVERSITY, IMO STATE",
  "LAGOS STATE UNIVERSITY (LASU), LAGOS STATE",
  "THE POLYTECHNIC, IBADAN, OYO STATE",
  "FEDERAL POLYTECHNIC, NEKEDE, IMO STATE",
  "YABA COLLEGE OF TECHNOLOGY (YABATECH), LAGOS STATE",
  "COVENANT UNIVERSITY, OGUN STATE",
  "BABCOCK UNIVERSITY, OGUN STATE",
  "REDEEMER'S UNIVERSITY, OSUN STATE",
  "Others",
];

export const DOCUMENT_TYPES = [
  "O Level Certificate",
  "Graduate Certificate (BSc/HND)",
  "Professional Certificate",
  "Work Experience Letter",
  "Employer Confirmation Letter",
  "Professional Membership Certificate",
  "Logbook Stage 3 Certificate",
  "Interview Certificate",
  "Birth Certificate",
];

export const FELLOWSHIP_DOCUMENT_TYPES = [
  "MNIQS Certificate",
  "QSRBN Practise License",
  "Professional Citation",
  "Evidence of Benevolence",
];

export const FIRM_DOCUMENT_TYPES = [
  "Certificate of Incorporation / Business Name Registration",
  "NIQS Membership Certificate of Principal Partner",
  "QSRBN Practice License",
  "CV of Principal Partner",
];

export const FIRM_OWNERSHIP_STRUCTURES = [
  "Sole Proprietorship",
  "Limited Liability Partnership",
  "Limited Partnership",
  "Private Company Limited by Shares",
  "Public Company Limited by Shares",
  "Company Limited by Guarantee",
  "Unlimited Company",
];

export const BENEVOLENCE_TYPES = [
  "Service to the Institute - National Bodies/Chapter/National",
  "Financial Support - National Bodies/Chapter/National",
  "Scholarship/Bursary - National Bodies/Chapter/National",
  "Publication - National Bodies/Chapter/National",
  "Others",
];

export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export function getYears(from = 1960): string[] {
  const end = new Date().getFullYear();
  return Array.from({ length: end - from + 1 }, (_, i) => String(end - i));
}
